import React from 'react'
import AttachmentIcon from 'components/App/DesktopView/shared/Composer/shared/AttachmentIcon'
import { SVGIcon } from 'shared/ui'

const AttachmentButton = React.memo(props => {
  return <AttachmentIcon icon={<SVGIcon name="updatedAttach" />} {...props} />
})

export default AttachmentButton
